import { SocialNetwork } from './social';

// --- Campaign ---

export interface Campaign {
  id: string;
  name: string;
  clientName: string | null;
  postsPerAccountPerWeek: number;
  rotationCycleWeeks: number;
  bufferMinWeeks: number;
  bufferMaxWeeks: number;
  platforms: SocialNetwork[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string | null;
  workspaces?: CampaignWorkspace[];
  batches?: CampaignBatch[];
}

export interface CampaignWorkspace {
  id: string;
  campaignId: string;
  workspaceId: string;
  workspaceName: string;
  groupLabel: 'A' | 'B';
  sortOrder: number;
  weeksAhead?: number;
  lastBatchDate?: string | null;
  logoUrl?: string | null;
}

export interface CampaignBatch {
  id: string;
  campaignId: string;
  groupLabel: 'A' | 'B';
  weekLabel: string;
  status: 'pending' | 'generating' | 'completed' | 'failed';
  totalPosts: number;
  generatedPosts: number;
  targetStartDate: string | null;
  targetEndDate: string | null;
  startedAt: string | null;
  completedAt: string | null;
  errorMessage: string | null;
  createdAt: string;
}

export interface CampaignBatchPost {
  id: string;
  batchId: string;
  workspaceId: string;
  postId: string;
  scheduledDate: string | null;
  scheduledTime: string | null;
  createdAt: string;
}

// --- Requests ---

export interface CreateCampaignRequest {
  name: string;
  clientName?: string;
  postsPerAccountPerWeek?: number;
  rotationCycleWeeks?: number;
  bufferMinWeeks?: number;
  bufferMaxWeeks?: number;
  platforms: SocialNetwork[];
  workspaces?: { workspaceId: string; groupLabel: 'A' | 'B' }[];
}

export interface UpdateCampaignRequest {
  name?: string;
  clientName?: string;
  postsPerAccountPerWeek?: number;
  rotationCycleWeeks?: number;
  bufferMinWeeks?: number;
  bufferMaxWeeks?: number;
  platforms?: SocialNetwork[];
  isActive?: boolean;
}

export interface GenerateBatchRequest {
  groupLabel: 'A' | 'B';
  targetStartDate: string;
}

// --- Buffer Status ---

export interface BufferStatusEntry {
  workspaceId: string;
  workspaceName: string;
  groupLabel: 'A' | 'B';
  logoUrl: string | null;
  weeksAhead: number;
  lastScheduledDate: string | null;
  totalScheduledPosts: number;
  status: 'critical' | 'warning' | 'healthy';
}

export interface CampaignBufferStatus {
  campaignId: string;
  bufferMinWeeks: number;
  bufferMaxWeeks: number;
  entries: BufferStatusEntry[];
  nextGroupDue: 'A' | 'B';
}

// --- GHL Export ---

export interface GHLExportRow {
  postAtSpecificTime: string;
  content: string;
  link: string;
  imageUrls: string;
  gifUrl: string;
  videoUrls: string;
}
